export const locale = {
    lang: 'en',
    data: {
        "TOOLBAR" : {
            "CHANGE_PASSWORD": "Change password",
            "LOGOUT": "Logout"
        }
    }
};